module.exports = [{"tabName":"HOME","children":[],"url":"/pc/home","target":"none"},{"tabName":"产品中心","children":[],"url":"/pc/produce","target":"none"},{"tabName":"微服务","children":[],"url":"/pc/server","target":"none"},{"tabName":"关于我们","children":[],"url":"/pc/aboutUs","target":"none"},{"tabName":"友情链接","url":"#","target":"none","children":[{"tabName":"福音影视","url":"https://www.ifuyin.tv/","target":"_blank"},{"tabName":"赞美诗网","url":"http://www.zanmeishi.com/","target":"_blank"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/json/pc/header.json
// module id = JSAD
// module chunks = 0